<span *ngIf="!loading">{{nonLoadingText}}</span>
<span *ngIf="loading">{{loadingText}}&nbsp;<app-spinner></app-spinner></span>
